module.exports = __webpack_public_path__ + "images/e11be8a1d3ee156fc54706191eb0add5-CSP_PlatinumBadge.png";